// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__33ws0","info":"UpdateTermsInfo_info__1gxVt"};